import { z } from 'zod'

export const addTagSchema = z.object({
  presentationId: z.string(),
  tag: z.string(),
})

export type AddTag = z.infer<typeof addTagSchema>
